module.exports = __webpack_public_path__ + "img/smiley-abounce.e8feac50.gif";